<template>
    <div class="container container--budget">  

        <Loader v-if="!ready || processing"></Loader>

        <article class="budget" v-if="ready">

            <header class="budget__heading">
                <h1 class="woocommerce-order-details__title" v-if="isNew">Créer un nouvel utilisateur</h1>
                <h1 class="woocommerce-order-details__title" v-if="!isNew">Modifier l'utilisateur</h1>
            </header> 

            <Edit class="edit"
                @submit.native="checkForm">

                <fieldset class="edit__fieldset">
                    <div class="edit__field edit__field--main"
                        :class="{ 'error': errors.includes('name') }"> 
                        <label class="edit__field__label" for="name">Nom</label>
                        <input class="edit__field__input"
                            type="text"
                            id="name"
                            v-model="utilisateur.name"
                            placeholder="Nom de l'utilisateur" />
                    </div>

                    <div class="edit__field"
                        :class="{ 'error': errors.includes('profil') }"> 
                        <label class="edit__field__label" for="profil">Profil</label>
                        <select class="edit__field__input"
                            id="profil"
                            v-model="utilisateur.profilId"
                            @change="updateProfil">
                            <option :value="null" disabled="disabled">Sélectionner un profil</option>
                            <option v-for="profil in profils"
                                :key="profil.id"
                                :value="profil.id">
                                {{ profil.nom }}
                            </option>
                        </select>
                    </div>

                    <div class="edit__field"
                        :class="{ 'error': errors.includes('email') }"> 
                        <label class="edit__field__label" for="email">Adresse e-mail</label>
                        <input class="edit__field__input"
                            type="email"
                            id="email"
                            v-model="utilisateur.email"
                            placeholder="Adresse e-mail" />
                    </div>

                    <div class="edit__field"
                        :class="{ 'error': errors.includes('password') }"> 
                        <label class="edit__field__label" for="password">Mot de passe</label>
                        <input class="edit__field__input"
                            type="password"
                            id="password"
                            v-model="utilisateur.password"
                            placeholder="Nouveau mot de passe" />
                    </div>

                    <div class="edit__field"
                        :class="{ 'error': errors.includes('validityFrom') || errors.includes('validityTo') }"> 
                        <label class="edit__field__label" for="validityFrom">Valide du</label>
                        <Datepicker class="edit__field__input"
                            id="validityFrom"
                            :language="datepickerLocale"
                            :monday-first="datepickerMondayFirst"
                            v-model="utilisateur.validiteDebut"
                            placeholder="jj/mm/aaaa" />
                        <label class="edit__field__label" for="validityTo"> au </label>
                        <Datepicker class="edit__field__input"
                            id="validityTo"
                            :language="datepickerLocale"
                            :monday-first="datepickerMondayFirst"
                            v-model="utilisateur.validiteFin"
                            placeholder="jj/mm/aaaa" />
                    </div>

                </fieldset>

                <div class="edit__actions">                                
                    <button class="woocommerce-button button alt"
                        type="submit"
                        value="submit"
                        v-if="isNew">Créer</button>                    
                    <button class="woocommerce-button button alt"
                        type="submit"
                        value="submit"
                        v-if="!isNew">Modifier</button>        
                    <router-link class="woocommerce-button button"
                        :to="{ name: 'utilisateurList' }">Annuler</router-link>
                </div>

            </Edit>

        </article>

    </div>
</template>

<script>
import { mapState } from 'vuex'

import api from '@/api/proxyWeb/utilisateurs'
import { actions } from '@/store/utilisateurs'

import title from "@/containers/title";

import Datepicker from 'vuejs-datepicker'
import * as DATEPICKER_LOCALES from "vuejs-datepicker/src/locale"
import Edit from '@/components/edit/Edit.vue'
import Loader from '@/components/loader/Loader.vue'


export default {

    name: 'Budget',

    data: function() {
        return {
            datepickerLocale: DATEPICKER_LOCALES['fr'],
            datepickerMondayFirst: true,
            utilisateur: {
                id: null,
                code: '',
                email: '',   
                name: '',
                profil: null,
                profilId: null,
                password: '',            
                validiteDebut: null,
                validiteFin: null,
            },
            errors: [],
            processing: false,
            ready: false
        }
    },

    computed: {

        isNew: function() { return ( this.ready && this.utilisateur.id === null ) },

        ...mapState({

            profils: state => {

                let currentProfilId = state.utilisateurs.current.profilId
                let profils = [
                    { id: 1, nom: 'Approvisionneur' }
                ]

                if ( currentProfilId >= 2 ) {
                    profils.push({ id: 2, nom: 'Acheteur' })
                }

                if ( currentProfilId >= 3 ) {
                    profils.push({ id: 3, nom: "Responsable d'achat" })
                }

                if ( currentProfilId >= 4 ) {
                    profils.push({ id: 4, nom: "Directeur d'achat" })
                }
                
                profils.push({ id: 5, nom: 'Représentant' })

                return profils
            }

        })
    },

    methods: {

        checkForm: function(e) {

            e.preventDefault()

            this.errors = []
            if ( this.utilisateur.name === '' ) {
                this.errors.push('name')
            }
            if ( this.utilisateur.email === '' ) {
                this.errors.push('email')
            }
            if ( this.utilisateur.profilId == null ) {
                this.errors.push('profil')
            }
            if ( ( this.utilisateur.id !== null && this.utilisateur.password !== '' && this.utilisateur.password.length < 6 )
                || ( this.utilisateur.id === null && this.utilisateur.password.length < 6 ) ) {
                this.errors.push('password')
            }
            if ( !this.utilisateur.validiteDebut ) {
                this.errors.push('validityFrom')
            }            
            if ( !this.utilisateur.validiteFin ) {
                this.errors.push('validityTo')
            }

            if ( this.errors.length > 0 ) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return
            }

            this.processing = true

            let now = new Date()
            this.utilisateur.isActif = ( now >= new Date(this.utilisateur.validiteDebut) && now < new Date(this.utilisateur.validiteFin) )

            let action = ( this.isNew ) ? actions.ADD : actions.UPDATE
            let successMsg = ( this.isNew ) ? 'Utilisateur créé' : 'Utilisateur modifié'
            let errorMsg = 'Une erreur est survenue'
            
            this.$store.dispatch(action, this.utilisateur)
                .then(() => {
                    this.$notify.success(successMsg)
                    this.$router.push({ name: "utilisateurList" })
                })
                .catch( e => {
                    if ( e.response.status === 422 ) {
                        errorMsg = e.response.data.error
                    }
                    this.$error( errorMsg )
                })
                .finally(() => {
                    this.processing = false
                })
        },

        updateProfil: function() {

            this.profils.forEach(profil => {
                if ( profil.id == this.utilisateur.profilId ) {
                    this.utilisateur.profil = profil;
                }
            })
        }
    },
  
    created() {
        
        this.id = ( this.$route.params.id ) ?? null
        if ( this.id ) {
            api.get(this.id)
                .then( utilisateur => {
                    this.utilisateur = utilisateur
                    this.utilisateur.password = '';
                    this.ready = true 
                })
                .catch(error => {
                    this.$errorPage(error.reason)
                })
        }
        else {
            this.ready = true
        }
    },

    components: {
        Datepicker,
        Edit,
        Loader
    },

    mixins: [ title ]
}
</script>

<style>

.budget {
    position: relative;
}

.budget__heading {
    margin-bottom: 2rem;
}

.budget__heading__actions {
    position: absolute;
    right: 0;
    top: 0;
}

.budget__footer {
}

.budget__footer__actions {
    text-align: right;
}

.utilisateurs,
.utilisateurs__item {
    list-style-type: none;
    margin: 0;
}

.utilisateur .utilisateur__name {
    padding: 0.5rem 1rem;
}

.negative {
    color: rgb(255, 48, 0);
}  

</style>
